import { cn } from '@/lib/cn';
import { sexSymbol } from '@/lib/format';
import { ImageOff } from 'lucide-react';

type AnimalAvatarProps = {
  coverPhotoUrl?: string | null;
  internalNumber?: string;
  sex?: 'male' | 'female';
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
};

const sizes = {
  sm: 'h-9 w-9 text-sm',
  md: 'h-12 w-12 text-base',
  lg: 'h-20 w-20 text-xl',
  xl: 'h-28 w-28 text-2xl',
  '2xl': 'h-36 w-36 text-2xl',
};

export function AnimalAvatar({
  coverPhotoUrl,
  internalNumber,
  sex,
  size = 'md',
  className,
}: AnimalAvatarProps) {
  const label = internalNumber ?? 'Animal';

  return (
    <div
      className={cn(
        'relative shrink-0 overflow-hidden rounded-xl bg-manejai-sand/60 ring-1 ring-manejai-sand',
        sizes[size],
        className,
      )}
      aria-label={label}
    >
      {coverPhotoUrl ? (
        <img src={coverPhotoUrl} alt={label} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center text-manejai-bark/45">
          <ImageOff
            className={cn(
              size === 'sm' ? 'h-3.5 w-3.5' : size === '2xl' ? 'h-8 w-8' : size === 'xl' ? 'h-7 w-7' : 'h-5 w-5',
            )}
          />
          {sex && size !== 'sm' && (
            <span className="mt-0.5 text-xs leading-none">{sexSymbol(sex)}</span>
          )}
        </div>
      )}
    </div>
  );
}
